module.exports = __webpack_public_path__ + "static/media/blurred.b215340c.webp";